import type { EntregaFormState } from '../../domain/EntregaFormState.ts';
import type { EntregaMapDisplay, EntregaMapPort } from '../../domain/ports/EntregaMapPort.ts';
import type { EntregaPdfImage } from '../../domain/EntregaPdfModel.ts';
import { entregaMapEmbedUrl, prepareEntregaMapView } from '../../domain/entregaMapModel.ts';
import {
  getEntregaMapCompositeUrl,
  getEntregaMapCompositeDataUrl,
  hydrateEntregaMapCompositeFromCache,
  warmEntregaMapComposite,
} from './entregaMapTileCache.ts';

export class BrowserEntregaMapAdapter implements EntregaMapPort {
  resolveDisplay(state: EntregaFormState, width: number, height: number): EntregaMapDisplay {
    const online = globalThis.navigator?.onLine ?? true;
    void hydrateEntregaMapCompositeFromCache(state);
    const offlineCompositeUrl = getEntregaMapCompositeUrl(state);
    return {
      online,
      embedUrl: online ? entregaMapEmbedUrl(state) : null,
      offlineCompositeUrl: online ? null : offlineCompositeUrl,
      offlineMapHint:
        !online && !offlineCompositeUrl
          ? 'Sin mapa en caché. Conéctese a la red y abra el formulario para guardar tiles offline.'
          : null,
      view: prepareEntregaMapView(state, width, height),
    };
  }

  refreshOfflineTiles(state: EntregaFormState, width: number, height: number): Promise<void> {
    return warmEntregaMapComposite(state, width, height);
  }

  async getCompositeImageDataUrl(
    state: EntregaFormState,
    width: number,
    height: number,
  ): Promise<EntregaPdfImage | null> {
    const dataUrl = await getEntregaMapCompositeDataUrl(state, width, height);
    return dataUrl ? { dataUrl, format: 'JPEG' } : null;
  }

  subscribeConnectivity(onChange: () => void): () => void {
    globalThis.addEventListener('online', onChange);
    globalThis.addEventListener('offline', onChange);
    return () => {
      globalThis.removeEventListener('online', onChange);
      globalThis.removeEventListener('offline', onChange);
    };
  }
}
